import React from 'react';
import { Link } from 'react-router-dom';
import { highlight } from 'components/lotto/utility/Utility';

export default function LuckyNumberLinks({ text, slug }) {
  if (!text) return null;

  const numbers = text.split(',');
  let countNum = 1;

  return (
    <span className="lucky-numbers" role="list">
      {numbers.map((n, i) => {
        const trimmed = n.trim();
        if (!isNaN(+trimmed)) {
          const content =
            slug && slug.length === trimmed.length
              ? highlight(trimmed, slug)
              : trimmed;
          return (
            <span key={i} className="lucky-number-group" role="listitem">
              <Link
                to={`/search/${trimmed}`}
                className="lucky-number-link"
                title={`เช็คสถิติเลข ${trimmed}`}
              >
                {content}
              </Link>
              {countNum++ % 10 === 0 ? <br /> : ' '}
            </span>
          );
        }
        return (
          <span key={i}>
            {i === 0 ? '' : <br />}
            {trimmed}&nbsp;
          </span>
        );
      })}
    </span>
  );
}
